export default __webpack_public_path__ + "static/media/logo-dark.91e55d6a.svg";